<template>
	<div class="category-animation-8-bg">
		<!--<transition name="fade-long">
			<div v-if="withFade" class="category-animation-5-bg__fade"></div>
		</transition>-->
		<video autoplay
			   muted
			   loop
			   playsinline
			   class="anim-fade-in"
			   @loadeddata="withFade=false">
			<source src="@/assets/animations/8/bg-text.mp4" type="video/mp4">
		</video>
	</div>
</template>

<script>
	export default {
		name: "category-animation-8-bg",
		components: {},
		data: () => {
			return {
				withFade: false,
			}
		},
	}
</script>

<style lang="scss">
	.category-animation-8-bg {
		position: absolute;
		top: -18px !important;
		left: 50%;
		transform: translateX(-49.73%);
		width: 90vw;
		height: 480px;

		/*@include up($md) {
			height: 280px;
		}

		@include up($lg) {
			height: 320px;
		}*/

		video {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

</style>